export const lotDetailsFragment = `
  fragment lotDetailsFields on CpscItem {
    lotInformation {
      lotNumberAssigner
      lotNumber
      productionStartDate
      productionEndDate
    }
  }
`;
